// extracted by mini-css-extract-plugin
export default {"wrapper":"cocR9bg6MAw5o0Pb2vAk","avatar":"FUjwE6ifEgXhiMmZurus","diffNbUsers":"BILp6p668cmcEczaetQB"};